/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// toggles
import Switch from 'material/toggle/switch/switch';
import CheckBox from 'material/toggle/checkbox/checkbox';
// styles
import injectSheet from 'react-jss';
import styles from 'material/toggle/toggle_styles'


/* ========== ~~~~~~~~~~ TOGGLE : CHILD ~~~~~~~~~~ ========== */
class Toggle extends Component{
    constructor(props){
        super(props);
        this.state = { on: this.props.on === 'on' || this.props.on === true }
    }
    handleOn = () => {
        return this.props.on === 'on' || this.props.on === true;
    };
    handleClick = (e) => {
        if(!!this.props.handleClick) this.props.handleClick(this.props.value, !this.state.on);
        this.setState({on: !this.state.on});
    };
    renderType = () => {
        let {variant, color} = this.props;
        switch (this.props.type) {
            case 'switch':
                return <Switch on={this.handleOn()} variant={variant} />;
            case 'checkbox':
                return <CheckBox handleClick={this.handleClick} on={this.state.on} color={color} />;
            default:
                return null;
        }
    };
    render(){
        return (
            <div className={`toggle ${this.props.classes.toggle}`} onClick={this.handleClick}>{this.renderType()}</div>
        )
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Toggle);